type Props = {
  onChange: (elem: React.FormEvent<HTMLInputElement> | string) => void
  error: string
}
const HasLaptopField = ({ onChange, error }: Props): JSX.Element => (
  <div className="flex flex-col mt-4">
    <span className="text-grey text-md font-600">
      Do you have a laptop/desktop/MacBook at home for the class?
    </span>
    <div className="flex space-x-5 my-2 text-grey">
      <div className="flex items-center space-x-1">
        <input
          type="radio"
          name="hasLaptop"
          id="yes"
          className="cursor-pointer"
          value="yes"
          onChange={onChange}
        />
        <label htmlFor="yes">Yes</label>
      </div>
      <div className="flex items-center space-x-1">
        <input
          type="radio"
          name="hasLaptop"
          id="no"
          className="cursor-pointer"
          value="no"
          onChange={onChange}
        />
        <label htmlFor="no">No</label>
      </div>
    </div>
    {error && (
      <div className="text-red-200 text-sm leading-4 font-400">{error}</div>
    )}
  </div>
)

export default HasLaptopField
